Vue.component('tour-list', {
	template: `
	<div id="tour_dynamic">
		<div class="filter_bar">
			<div class="bottom_bar">
				<div class="flex items-center" v-if="destinationList.length > 1">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
						<path d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm2-2.25a8 8 0 0 0 4-2.46V9a2 2 0 0 1-2-2V3.07a7.95 7.95 0 0 0-3-1V3a2 2 0 0 1-2 2v1a2 2 0 0 1-2 2v2h3a2 2 0 0 1 2 2v5.75zm-4 0V15a2 2 0 0 1-2-2v-1h-.5A1.5 1.5 0 0 1 4 10.5V8H2.25A8.01 8.01 0 0 0 8 17.75z"/>
					</svg>
					<span class="mx-1/8">Destination</span>
					<select v-model="selectedDestination" @change="selectedLocale = 'all'">
						<option value="all">All</option>
						<option v-for="destination in destinationList" :value="destination" v-text="destination"></option>
					</select>
				</div>
				<div class="flex items-center" v-if="localeList.length > 1">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
						<path d="M0 0l6 4 8-4 6 4v16l-6-4-8 4-6-4V0zm7 6v11l6-3V3L7 6z"/>
					</svg>
					<span class="mx-1/8">Locale</span>
					<select v-model="selectedLocale">
						<option value="all">All</option>
						<option v-for="locale in localeList" :value="locale" v-text="locale"></option>
					</select>
				</div>
				<div class="flex items-center">
					<span class="mx-1/8">Price</span>
					<button class="flex items-center p-1/8" @click="sortDirection == 'asc'? sortDirection = 'desc': sortDirection = 'asc'">
						<svg width="17px" height="17px" viewBox="0 0 17 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
							<g :transform="'rotate('+(sortDirection=='asc'?90:270)+' 8 8)'">
									<polygon points="16.32 7 11.5 0 6.5 0 10 5 0 5 0 9 10 9 6.5 14 11.5 14"></polygon>
							</g>
						</svg>
					</button>
				</div>
			</div>
		</div>

		<div v-for="group in filteredGroups" class="locale_card">
			<h4 v-text="group.heading"></h4>
			<div class="wrappackages">

				<div v-for="tour in group.tours" class="accommodation_card">
					<div class="image" :style="'background-image: url('+tour.image_url+')'">
					</div>
					<div class="head">
						<h5>
							{{ tour.name }}
						</h5>
					</div>
					<div class="details" :class="{tour_fadein: opens[tour.opt]}"><p v-html="opens[tour.opt]?tour.description:tour.truncated_description"></p>
						<div v-if="opens[tour.opt] == false">
							<button type="button" class="info right" @click="openIt(tour.opt)">More info</button>
						</div>
					</div>
				</div>

			</div>
			<div v-if="!group.tours || group.tours.length==0" >
				<p>No Results</p>
			</div>
		</div>
		<slot></slot>
	</div>
	`,
	data(){
		return {
			selectedTours: 'all',
			selectedDestination: Project.selectedDestination?Project.selectedDestination:'all',
			selectedLocale: Project.selectedLocale?Project.selectedLocale:'all',
			sortBy: 'lowest_price',
			sortDirection: 'asc',
			tours: [],
			opens: {},
			localeGroup: false
		}
	},
	created() {
		this.tours = this.$children

	},
	mounted() {
		this.tours.forEach(tour => {
			this.opens[tour.opt] =  tour.description == tour.truncated_description
		})
	},
	watch:{
		url: function() {
			history.pushState({}, null, this.url)
		},
	},
	methods: {
		openIt(opt){
			this.opens[opt] = true
			this.$forceUpdate()
		}
	},
	computed: {
		destinationList() {
			let values = this.tours

			values = _.sortBy(values, ['destination_order'])
			values = values.map( ( s_tour ) => {
				return s_tour.destination
			})
			values = _.uniq(values)
			return values
		},
		localeList() {
			let values = this.tours
				.filter( s_tour => {
					return s_tour.destination == this.selectedDestination || this.selectedDestination == 'all'
				})
				.map( s_tour => {
					return s_tour.locale
				})
			values = _.uniq(values)
			return values
		},
		filteredGroups() {

			// Sortby ---------------------------------------
			let filteredTours = this.tours

			filteredTours = _.sortBy(filteredTours, 'price')

			if (this.sortDirection == 'desc'){
				filteredTours = filteredTours.reverse()
			}

			// filteredTours = filteredTours.map((tour) => {
			// 	tour.open = tour.description == tour.truncated_description
			// 	return tour
			// })

			if (this.selectedDestination!='all'){
				filteredTours = filteredTours.filter((destination) => {
					return destination.destination == this.selectedDestination
				})
			}

			let locales = _.groupBy(filteredTours, 'locale')
			let group = _.map(locales, (tour) => {
				return {
					heading: tour[0].locale,
					tours: tour,
					order: tour[0].destination_order + '.'+ tour[0].locale_order
				}
			})

			if (this.selectedLocale!='all'){
				group = group.filter((locale) => {
					return locale.heading == this.selectedLocale
				})
			}

			return _.sortBy(group, 'order')

		},
		url() {
			if (this.selectedLocale != 'all'){
				return '/tours/'+this.selectedDestination.toLowerCase().replaceAll(' ', '-')+'/'+this.selectedLocale.toLowerCase().replaceAll(' ', '-')
			}
			return '/tours/'+this.selectedDestination.toLowerCase().replaceAll(' ', '-')
		},
	}
})

Vue.component('tour', {
	template: '<div><slot></slot></div>',
	props: {
		opt: { required: true },
		name: { required: true },
		destination: {},
		destination_slug: {},
		destination_order: {},
		locale: {},
		locale_order: {},
		image_url: {},
		price: { type: Number },
		pp: {},
		description: {},
		truncated_description: {},
	}

})


